var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-0 mr-0",attrs:{"block":_vm.block !== undefined,"small":_vm.small !== undefined,"depressed":_vm.depressed !== undefined,"color":_vm.color,"loading":_vm.state},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }